import { IReduxAction } from '../../../services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_LOADING_SEND,
  GET_ALL_SUCCESS,
  GET_BY_ID_SUCCESS,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  GET_PRODUCTS_SUCCESS,
  SEARCH,
  SET_LOADING_SELECTS
} from './order-split-constants';

const INITIAL_STATE = {
  loadingData: true,
  loadingSend: false,
  loadingSelects: false,
  form: {
    data: null,
    errors: [],
    selects: null
  },
  list: {
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    selected: [],
    selectedCount: 0,
    order: 'desc',
    orderBy: 'createdAt'
  }
};

const orderSplitReducer = (state = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SEND: {
      return {
        ...state,
        loadingSend: action.loading
      };
    }

    case SET_LOADING_SELECTS: {
      return {
        ...state,
        loadingSelects: action.loading
      };
    }

    case GET_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload,
          allRows: action.payload
        }
      };
    }

    case SEARCH: {
      const { queryText } = action;

      const results =
        queryText !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item.originSubsidiaryName.toLowerCase().startsWith(queryText.toLowerCase()) ||
                item.originSubsidiaryName.toLowerCase().includes(queryText.toLowerCase()) ||
                item.originSubsidiaryExternalCode.toString().startsWith(queryText) ||
                item.originSubsidiaryExternalCode.toString().includes(queryText) ||
                item.finalSubsidiaryName.toLowerCase().startsWith(queryText.toLowerCase()) ||
                item.finalSubsidiaryName.toLowerCase().includes(queryText.toLowerCase()) ||
                item.finalSubsidiaryExternalCode.toString().startsWith(queryText) ||
                item.finalSubsidiaryExternalCode.toString().includes(queryText)
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    case GET_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          ...action.payload,
          selects: {
            ...state.form.selects,
            ...action.payload.selects
          }
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case GET_PRODUCTS_SUCCESS: {
      return {
        ...state,
        form: {
          ...state.form,
          selects: {
            ...state.form.selects,
            products: action.payload
          }
        }
      };
    }

    default:
      return state;
  }
};

export default orderSplitReducer;
